import React from 'react';
import Tag from './Tag';
import Tooltip from './Tooltip';
import { getTagExplanation } from '../../utils/tagUtils';
import { Tag as TagType } from '../../types/types';

interface TagListProps {
  tags: TagType[];
  onTagHover: (tag: TagType) => void;
  onTagHoverOut: () => void;
}

const scores = {
  'Extremely Likely': 3,
  'Moderate': 2,
  'Extremely Unlikely': 1,
  'Unlikely': 1
};

const TagList: React.FC<TagListProps> = ({ tags, onTagHover, onTagHoverOut }) => {
  const tags_sorted = tags.sort((a, b) => {
    return scores[b.likelihood] - scores[a.likelihood];
  })
    
  return (
    <div className="tag-list">
      {tags_sorted.map((tag, index) => {
        const { description, color } = getTagExplanation(tag?.frame);
        return (
          <Tooltip key={index} content={tag.explanation || description} color={color} onMouseEnter={() => onTagHover(tag)} onMouseLeave={onTagHoverOut}>
            <Tag tag={tag} />
          </Tooltip>
        );
      })}
    </div>
  )
}

export default TagList;